/* ============================================================
   PROGREENS — SHARED JS
   Nav shrink · Mobile menu · Fade-up · Bundle state
   ============================================================ */

(function () {
  'use strict';

  /* ── NAV SHRINK ON SCROLL ── */
  const nav = document.getElementById('main-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* ── MOBILE MENU ── */
  const menuBtn  = document.querySelector('.mobile-menu-btn');
  const navLinks = document.querySelector('.nav-links');
  if (menuBtn && navLinks && nav) {
    menuBtn.addEventListener('click', function () {
      const expanded = menuBtn.getAttribute('aria-expanded') === 'true';
      menuBtn.setAttribute('aria-expanded', String(!expanded));
      if (!expanded) {
        navLinks.style.cssText = [
          'display:flex',
          'flex-direction:column',
          'position:fixed',
          'top:' + nav.offsetHeight + 'px',
          'left:0',
          'width:100%',
          'background:rgba(253,252,250,0.98)',
          'backdrop-filter:blur(20px)',
          '-webkit-backdrop-filter:blur(20px)',
          'padding:1.5rem 5%',
          'gap:1.2rem',
          'border-bottom:1px solid rgba(99,153,34,0.15)',
          'z-index:999'
        ].join(';');
      } else {
        navLinks.removeAttribute('style');
      }
    });

    /* Close mobile menu on link click */
    navLinks.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        navLinks.removeAttribute('style');
        menuBtn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ── FADE-UP OBSERVER ── */
  if ('IntersectionObserver' in window) {
    var fadeObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          fadeObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });

    document.querySelectorAll('.fade-up').forEach(function (el) {
      fadeObs.observe(el);
    });
  } else {
    /* Fallback: show everything immediately */
    document.querySelectorAll('.fade-up').forEach(function (el) {
      el.classList.add('visible');
    });
  }

  /* ── BUNDLE STATE (localStorage) ── */
  var BUNDLE_KEY = 'pg_bundle';
  var BUNDLE_MAX = 8;

  window.PGBundle = {
    get: function () {
      try {
        return JSON.parse(localStorage.getItem(BUNDLE_KEY) || '{}');
      } catch (e) {
        return {};
      }
    },

    save: function (state) {
      try {
        localStorage.setItem(BUNDLE_KEY, JSON.stringify(state));
      } catch (e) {}
      this.updateBar();
    },

    totalCount: function () {
      var state = this.get();
      return Object.values(state).reduce(function (sum, n) { return sum + n; }, 0);
    },

    add: function (handle, name, price) {
      var state = this.get();
      if (this.totalCount() >= BUNDLE_MAX) return false;
      state[handle] = (state[handle] || 0) + 1;
      /* Store name/price for display */
      var meta = this.getMeta();
      meta[handle] = { name: name, price: price };
      try { localStorage.setItem(BUNDLE_KEY + '_meta', JSON.stringify(meta)); } catch(e) {}
      this.save(state);
      return true;
    },

    remove: function (handle) {
      var state = this.get();
      if (state[handle] > 0) {
        state[handle]--;
        if (state[handle] === 0) delete state[handle];
      }
      this.save(state);
    },

    clear: function () {
      try {
        localStorage.removeItem(BUNDLE_KEY);
        localStorage.removeItem(BUNDLE_KEY + '_meta');
      } catch (e) {}
      this.updateBar();
    },

    getMeta: function () {
      try {
        return JSON.parse(localStorage.getItem(BUNDLE_KEY + '_meta') || '{}');
      } catch (e) {
        return {};
      }
    },

    updateBar: function () {
      var count = this.totalCount();
      var bar   = document.getElementById('bundleBar');
      var countEl = document.getElementById('bundleBarCount');
      if (bar)     bar.classList.toggle('visible', count > 0);
      if (countEl) countEl.textContent = count;

      /* Avoid stacking the bundle bar with the homepage's floating sample CTA on mobile */
      document.body.classList.toggle('has-bundle-bar', count > 0);

      /* Also update any inline counter on the current page */
      var inlineCount = document.getElementById('varietyBundleCount');
      if (inlineCount) inlineCount.textContent = count;

      var inlineBar = document.querySelector('.vbc-count');
      if (inlineBar) inlineBar.textContent = count + '/8';
    }
  };

  /* Init bundle bar on load */
  window.PGBundle.updateBar();

  /* ── SEASON AVAILABILITY ──
     Grow-to-order model with 4 states per variety, always computed against
     TODAY (not a fixed reference date), so pages don't need re-deploying
     as the calendar moves:

       in-arrivo        → today is before the season's start date
       disponibile      → in season, and an order placed today would be
                           ready (today + lead time) with enough margin
                           before the season's end date
       chiuse           → in season, but an order placed today would be
                           ready too close to (or after) the season's end —
                           existing/scheduled orders still fulfil normally,
                           new bookings are closed
       fuori-stagione   → today is after the season's end date

     Season start/end are derived from the existing month-name fields:
     start = day 1 of monthFrom, end = last day of monthUntil, both anchored
     to the current year (rolling to next year for a wrapping window, e.g.
     Novembre → Marzo). The catalog's "In stagione ora" badge is a separate,
     manually-set field and does NOT use this. */
  window.PGSeason = {
    MONTH_MAP: {Gennaio:0,Febbraio:1,Marzo:2,Aprile:3,Maggio:4,Giugno:5,Luglio:6,Agosto:7,Settembre:8,Ottobre:9,Novembre:10,Dicembre:11},

        DEFAULT_MARGIN_DAYS: 10,
    DEFAULT_OPEN_MARGIN_DAYS: 15,

    _today: function () {
      var d = new Date();
      d.setHours(0, 0, 0, 0);
      return d;
    },

    _lastDayOfMonth: function (year, monthIndex) {
      var d = new Date(year, monthIndex + 1, 0);
      d.setHours(0, 0, 0, 0);
      return d;
    },

    _addDays: function (date, days) {
      var d = new Date(date);
      d.setDate(d.getDate() + days);
      return d;
    },

    getStatus: function (monthFrom, monthUntil, leadTimeDays, marginDays, openMarginDays) {
      var s = this.MONTH_MAP[monthFrom];
      var e = this.MONTH_MAP[monthUntil];

      if (s === undefined || e === undefined) {
        return { status: 'sempre', purchasable: true };
      }

      var lead = parseInt(leadTimeDays, 10);
      if (isNaN(lead)) lead = 0;

      var margin = parseInt(marginDays, 10);
      if (isNaN(margin)) margin = this.DEFAULT_MARGIN_DAYS;

      var openMargin = parseInt(openMarginDays, 10);
      if (isNaN(openMargin)) openMargin = this.DEFAULT_OPEN_MARGIN_DAYS;

      var today = this._today();
      var year  = today.getFullYear();

      var seasonStart = new Date(year, s, 1);
      var endYear = (s <= e) ? year : year + 1;
      var seasonEnd = this._lastDayOfMonth(endYear, e);

      var readyDate      = this._addDays(today, lead);
      var openCutoffDate = this._addDays(seasonStart, openMargin);
      var cutoffDate      = this._addDays(seasonEnd, -margin);

      var out = { seasonStart: seasonStart, seasonEnd: seasonEnd, readyDate: readyDate, openCutoffDate: openCutoffDate, cutoffDate: cutoffDate };

      if (today > seasonEnd) {
        out.status = 'fuori-stagione';
        out.purchasable = false;
      } else if (readyDate < openCutoffDate) {
        out.status = 'in-arrivo';
        out.purchasable = false;
      } else if (readyDate > cutoffDate) {
        out.status = 'chiuse';
        out.purchasable = false;
      } else {
        out.status = 'disponibile';
        out.purchasable = true;
      }
      return out;
    },

    willBeAvailable: function (monthFrom, monthUntil, leadTimeDays, marginDays, openMarginDays) {
      return this.getStatus(monthFrom, monthUntil, leadTimeDays, marginDays, openMarginDays).purchasable;
    }
  };

  /* ── TOAST NOTIFICATION ──
     Usage: PGToast('message') or PGToast({ message, actionText, actionHref }) */
  window.PGToast = function (input) {
    var existing = document.getElementById('pg-toast');
    if (existing) existing.remove();

    var opts = (typeof input === 'string') ? { message: input } : (input || {});

    var toast = document.createElement('div');
    toast.id = 'pg-toast';
    toast.className = 'pg-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    var msgEl = document.createElement('span');
    msgEl.className = 'pg-toast-msg';
    msgEl.textContent = opts.message || '';
    toast.appendChild(msgEl);

    if (opts.actionText && opts.actionHref) {
      var actionEl = document.createElement('a');
      actionEl.className = 'pg-toast-action';
      actionEl.href = opts.actionHref;
      actionEl.textContent = opts.actionText;
      toast.appendChild(actionEl);
    }

    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.classList.add('visible');
    });

    setTimeout(function () {
      toast.classList.remove('visible');
      setTimeout(function () { toast.remove(); }, 300);
    }, 3200);
  };

})();
